import Layout from '@/views/layout';

const orderRouter = {
  path: '/order',
  component: Layout,
  meta: { titlle: '订单', roles: [0, 1, 2, 3, 4] },
  redirect: { name: 'OrderList' },
  children: [
    {
      path: 'orderList',
      name: 'OrderList',
      component: () => import('@/views/orders/orderList'),
      meta: { title: '订单', roles: [0, 1, 2, 3, 4], noCache: true }
    },
    {
      path: 'orderDetails',
      name: 'OrderDetails',
      component: () => import('@/views/orders/orderDetails'),
      meta: { title: '订单详情', roles: [0, 1, 2, 3, 4], noCache: true }
    },
    {
      path: 'createOrder',
      name: 'CreateOrder',
      component: () => import('@/views/orders/createOrder'),
      meta: { title: '新建订单', roles: [0, 1, 2, 3, 4], noCache: false }
    }
  ]
};

export default orderRouter;